import {authFetch} from "../network";

export async function api_createGroup(payload) {
    return new Promise(resolve => {
        const res = (resp) => {
            resolve(resp)
        };

        authFetch("/groups/create", res, res, "POST", {payload});
    })

}